import en from './en'
import rs from './rs'
import hr from './hr'
import mk from './mk'
import si from './si'

const translations = {
  en: en,
  rs: rs,
  hr: hr,
  mk: mk,
  si: si
}

export default translations



// WEBPACK FOOTER //
// ./src/translations/index.js